require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[55],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("react-dom");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("react-dnd");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(476);


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SimpleTable = _interopRequireDefault(__webpack_require__(477));

exports["default"] = _SimpleTable["default"];
exports.SimpleTable = _SimpleTable["default"];

var _helper = _interopRequireDefault(__webpack_require__(86));

exports.SimpleTableHelpers = _helper["default"];

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _THead = _interopRequireDefault(__webpack_require__(478));

var _TBody = _interopRequireDefault(__webpack_require__(480));

var _TBodyDnD = _interopRequireDefault(__webpack_require__(481));

var _simpletable = _interopRequireDefault(__webpack_require__(51));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var stClassName = _simpletable["default"].stClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;

var SimpleTable = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SimpleTable, _Component);

  function SimpleTable() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SimpleTable.prototype;

  _proto.onSelect = function onSelect(row) {
    if (this.tbodydnd) {
      this.tbodydnd.onSelect(row);
    } else if (this.tbody) {
      this.tbody.onSelect(row);
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        rowLength = _this$props.rowLength,
        colToAddScopeRow = _this$props.colToAddScopeRow,
        caption = _this$props.caption,
        className = _this$props.className,
        colLength = _this$props.colLength,
        cellRenderer = _this$props.cellRenderer,
        headerRenderer = _this$props.headerRenderer,
        onRowMove = _this$props.onRowMove,
        onRowOut = _this$props.onRowOut,
        widthDivision = _this$props.widthDivision,
        height = _this$props.height,
        draggable = _this$props.draggable,
        onRowHover = _this$props.onRowHover,
        onRowClick = _this$props.onRowClick,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["rowLength", "colToAddScopeRow", "caption", "className", "colLength", "cellRenderer", "headerRenderer", "onRowMove", "onRowOut", "widthDivision", "height", "draggable", "onRowHover", "onRowClick"]);
    var tHeaderProps = {
      colLength: colLength,
      headerRenderer: headerRenderer,
      widthDivision: widthDivision
    };
    var tBodyProps = {
      rowLength: rowLength,
      colToAddScopeRow: colToAddScopeRow,
      colLength: colLength,
      cellRenderer: cellRenderer,
      onRowMove: onRowMove,
      onRowOut: onRowOut,
      widthDivision: widthDivision,
      height: height,
      draggable: draggable,
      onRowHover: onRowHover,
      onRowClick: onRowClick
    };
    return /*#__PURE__*/_react["default"].createElement("table", (0, _extends2["default"])({}, sanitize(others, SimpleTable), {
      className: stClassName + "-fixed-headers " + className
    }), caption && /*#__PURE__*/_react["default"].createElement("caption", {
      className: stClassName + "-caption"
    }, caption), /*#__PURE__*/_react["default"].createElement(_THead["default"], tHeaderProps), !this.props.draggable && /*#__PURE__*/_react["default"].createElement(_TBody["default"], (0, _extends2["default"])({
      ref: function ref(r) {
        _this.tbody = r;
      }
    }, tBodyProps)), this.props.draggable && /*#__PURE__*/_react["default"].createElement(_TBodyDnD["default"], (0, _extends2["default"])({
      ref: function ref(r) {
        _this.tbodydnd = r;
      }
    }, tBodyProps)));
  };

  return SimpleTable;
}(_react.Component);

exports["default"] = SimpleTable;
(0, _defineProperty2["default"])(SimpleTable, "propTypes", {
  /** Is the number of rows you plan to load in table */
  rowLength: _propTypes["default"].number,

  /** Custom class name(s) */
  className: _propTypes["default"].string,

  /** Set to column index for the first idnetifiable td that has text in a row. (accessibility requirement) */
  colToAddScopeRow: _propTypes["default"].number,

  /** A brief descriptive text, that indicates the content of that table (accessibility requirement) */
  caption: _propTypes["default"].string,

  /** Is the number of columns you plan to load in table */
  colLength: _propTypes["default"].number,

  /** Pass a callback function with row and column index as arguments */
  cellRenderer: _propTypes["default"].func,

  /** Pass a callback function with column index as arguments */
  headerRenderer: _propTypes["default"].func,

  /** Pass a callback function with arguments as source and target row index respectively */
  onRowMove: _propTypes["default"].func,

  /** Pass a callback function with arguments as row index. Triggers on row mouse out */
  onRowOut: _propTypes["default"].func,

  /** Set width division as key-value pair */
  widthDivision: _propTypes["default"].object,

  /** Set height of table */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Boolean value to make rows draggable */
  draggable: _propTypes["default"].bool,

  /** Pass a callback function with arguments as rowIndex. Triggers on row mouse over. */
  onRowHover: _propTypes["default"].func,

  /** Pass a callback function with arguments as rowIndex. Triggers on row click. */
  onRowClick: _propTypes["default"].func
});

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _Row = _interopRequireDefault(__webpack_require__(85));

var _simpletable = _interopRequireDefault(__webpack_require__(51));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var stClassName = _simpletable["default"].stClassName.replace(/"/g, '');

var THead = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(THead, _Component);

  function THead() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = THead.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement("thead", {
      className: stClassName + "-thead"
    }, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
      className: stClassName + "-thead-row",
      widthDivision: this.props.widthDivision,
      colLength: this.props.colLength,
      headerRenderer: this.props.headerRenderer,
      headerRow: true
    }));
  };

  return THead;
}(_react.Component);

exports["default"] = THead;
(0, _defineProperty2["default"])(THead, "propTypes", {
  headerRenderer: _propTypes["default"].func,
  colLength: _propTypes["default"].number,
  widthDivision: _propTypes["default"].object
});

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after{content:'';position:absolute;border-width:0;border-top-width:2px;border-style:solid;left:0;right:0;pointer-events:none;z-index:1;color:#1f57a4}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after,.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after{color:#fff}}.ba-common-simpletable-fixed-headers{width:100%;table-layout:fixed;border-collapse:collapse;background-color:#fff;display:block}.ba-common-simpletable-fixed-headers th,.ba-common-simpletable-fixed-headers td{display:block;text-align:left;vertical-align:middle}.ba-common-simpletable-caption{display:block}.ba-common-simpletable-thead{font-size:.875rem;font-weight:600;line-height:1.125rem;letter-spacing:.16px;background-color:#e0e0e0;display:block;width:100%}.ba-common-simpletable-thead-row{display:flex;flex-direction:row;width:100%}.ba-common-simpletable-thead-row th:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-thead-row .ba-common-checkbox{margin:5px 0}.ba-common-simpletable-tbody{font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px;background-color:#fff;overflow:auto;width:100%;display:block}.ba-common-simpletable-tbody-row{display:flex;flex-direction:row;width:100%;position:relative}.ba-common-simpletable-tbody-row:hover{background:#e5e5e5}.ba-common-simpletable-tbody-row:hover td{color:#161616;background:#e5e5e5;border-top:1px solid #e5e5e5;border-bottom:1px solid #e5e5e5}.ba-common-simpletable-tbody-row.is-selected,.ba-common-simpletable-tbody-row.is-selected:hover{background-color:rgba(31,87,164,0.1)}.ba-common-simpletable-tbody-row.is-selected td:first-child div.ba-common-container,.ba-common-simpletable-tbody-row.is-selected:hover td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px #1f57a4}.ba-common-simpletable-tbody-row.is-dragging{opacity:0.5}.ba-common-simpletable-tbody-row.is-active.is-hoveredBelow:after{bottom:-1px}.ba-common-simpletable-tbody-row.is-active.is-hoveredAbove:after{top:-1px}.ba-common-simpletable-tbody-row td:first-child div.ba-common-container{margin:0px 0px 0px 4px;box-shadow:-4px 0px transparent}.ba-common-simpletable-tbody-row td{display:block;color:#525252;background:#fff;border-top:1px solid #fff;border-bottom:1px solid #e0e0e0}.ba-common-simpletable-tbody-row .ba-common-checkbox{margin:4px 0}.old_ie_wrapper{width:100%;overflow-x:hidden;overflow-y:auto}.old_ie_wrapper tbody{height:auto}@media screen and (-ms-high-contrast: active){.ba-common-simpletable-tbody-row:hover{background-color:#1f57a4}}\n", ""]);

// exports
exports.locals = {
	"stClassName": "\"ba-common-simpletable\""
};

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _helper = _interopRequireDefault(__webpack_require__(86));

var _Row = _interopRequireDefault(__webpack_require__(85));

var _simpletable = _interopRequireDefault(__webpack_require__(51));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var stClassName = _simpletable["default"].stClassName.replace(/"/g, '');

var TBody = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TBody, _Component);

  function TBody() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_assignRef", function (ref, index) {
      _this["row" + index] = ref;
    });
    return _this;
  }

  var _proto = TBody.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _helper["default"].resizeThead(this.tbody);
  };

  _proto.onSelect = function onSelect(row) {
    this["row" + row].onSelect(row);
  };

  _proto.render = function render() {
    var _this2 = this;

    var height = {};

    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }

    var rows = [];

    var _loop = function _loop(index) {
      rows.push( /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        className: stClassName + "-tbody-row",
        onRef: function onRef(ref) {
          _this2._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: _this2.props.colToAddScopeRow,
        colLength: _this2.props.colLength,
        cellRenderer: _this2.props.cellRenderer,
        role: "bodyRow",
        widthDivision: _this2.props.widthDivision,
        onRowHover: _this2.props.onRowHover,
        onRowOut: _this2.props.onRowOut,
        onRowClick: _this2.props.onRowClick
      }));
    };

    for (var index = 0; index < this.props.rowLength; index++) {
      _loop(index);
    }

    return /*#__PURE__*/_react["default"].createElement("tbody", {
      ref: function ref(r) {
        _this2.tbody = r;
      },
      className: stClassName + "-tbody",
      style: height
    }, rows);
  };

  return TBody;
}(_react.Component);

exports["default"] = TBody;
(0, _defineProperty2["default"])(TBody, "propTypes", {
  rowLength: _propTypes["default"].number,
  colToAddScopeRow: _propTypes["default"].number,
  colLength: _propTypes["default"].number,
  cellRenderer: _propTypes["default"].func,
  onRowMove: _propTypes["default"].func,
  onRowOut: _propTypes["default"].func,
  widthDivision: _propTypes["default"].object,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  draggable: _propTypes["default"].bool,
  onRowHover: _propTypes["default"].func,
  onRowClick: _propTypes["default"].func
});

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _helper = _interopRequireDefault(__webpack_require__(86));

var _RowDnD = _interopRequireDefault(__webpack_require__(482));

var _simpletable = _interopRequireDefault(__webpack_require__(51));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var stClassName = _simpletable["default"].stClassName.replace(/"/g, '');

var TBodyDnD = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TBodyDnD, _Component);

  function TBodyDnD() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {});
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_assignRef", function (ref, index) {
      _this["rowdnd" + index] = ref;
    });
    return _this;
  }

  var _proto = TBodyDnD.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _helper["default"].resizeThead(this.tbody);
  };

  _proto.onSelect = function onSelect(row) {
    this["rowdnd" + row].onSelect(row);
  };

  _proto.render = function render() {
    var _this2 = this;

    var height = {};

    if (this.props.height) {
      height = {
        height: this.props.height
      };
    }

    var rows = [];

    var _loop = function _loop(index) {
      rows.push( /*#__PURE__*/_react["default"].createElement(_RowDnD["default"], {
        onRef: function onRef(ref) {
          _this2._assignRef(ref, index);
        },
        key: index,
        rowKey: index,
        colToAddScopeRow: _this2.props.colToAddScopeRow,
        colLength: _this2.props.colLength,
        rowLength: _this2.props.rowLength,
        cellRenderer: _this2.props.cellRenderer,
        widthDivision: _this2.props.widthDivision,
        onRowHover: _this2.props.onRowHover,
        onRowMove: _this2.props.onRowMove,
        onRowOut: _this2.props.onRowOut,
        hoveredAbove: _this2.state.hoveredAbove,
        role: "bodyRow"
      }));
    };

    for (var index = 0; index < this.props.rowLength; index++) {
      _loop(index);
    }

    return /*#__PURE__*/_react["default"].createElement("tbody", {
      ref: function ref(r) {
        _this2.tbody = r;
      },
      className: stClassName + "-tbody",
      style: height
    }, rows);
  };

  return TBodyDnD;
}(_react.Component);

(0, _defineProperty2["default"])(TBodyDnD, "propTypes", {
  rowLength: _propTypes["default"].number,
  colToAddScopeRow: _propTypes["default"].number,
  colLength: _propTypes["default"].number,
  cellRenderer: _propTypes["default"].func,
  onRowMove: _propTypes["default"].func,
  widthDivision: _propTypes["default"].object,
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  draggable: _propTypes["default"].bool,
  onRowHover: _propTypes["default"].func,
  onRowOut: _propTypes["default"].func
});
var _default = TBodyDnD;
exports["default"] = _default;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _reactDom = __webpack_require__(14);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _reactDnd = __webpack_require__(26);

var _Row = _interopRequireDefault(__webpack_require__(85));

var _simpletable = _interopRequireDefault(__webpack_require__(51));

var _dec, _dec2, _class, _class2, _temp;

var stClassName = _simpletable["default"].stClassName.replace(/"/g, '');

var style = {
  width: '100%',
  cursor: 'move'
};
/** Calculate position percentage of hovering on current row */

function getHoveredYPercent(props, monitor, component) {
  var hoverBoundingRect = (0, _reactDom.findDOMNode)(component).getBoundingClientRect();
  var clientOffset = monitor.getClientOffset();
  var hoverClientY = clientOffset.y - hoverBoundingRect.top;
  var hoveredYPercent = hoverClientY / (hoverBoundingRect.bottom - hoverBoundingRect.top) * 100;
  return hoveredYPercent;
}
/** Methods trigger when Element is dragged */


var draggableSource = {
  beginDrag: function beginDrag(props) {
    return {
      rowKey: props.rowKey
    };
  }
};

var connectDS = function connectDS(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  };
};
/** Methods trigger when Element is dropped */


var connectDT = function connectDT(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop()
  };
};

var draggableComponentTarget = {
  drop: function drop(props, monitor, component) {
    var hoveredYPercent = getHoveredYPercent(props, monitor, component);
    var sourceId = monitor.getItem().rowKey;
    var targetId = props.rowKey;
    if (sourceId === targetId) return; // move down

    if (sourceId < targetId) {
      if (hoveredYPercent > 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId - 1);
      } // move up

    } else if (sourceId > targetId) {
      if (hoveredYPercent < 50) {
        props.onRowMove(sourceId, targetId);
      } else {
        props.onRowMove(sourceId, targetId + 1);
      }
    }
  },
  hover: function hover(props, monitor, component) {
    var hoveredAbove = getHoveredYPercent(props, monitor, component) <= 50;
    var className = hoveredAbove ? (0, _utils.classnames)('hoveredAbove') : (0, _utils.classnames)('hoveredBelow');
    (0, _reactDom.findDOMNode)(component).classList.add(className);
  }
};
/** Custom Draggable Component */

var RowDnD = (_dec = (0, _reactDnd.DropTarget)('draggableList', draggableComponentTarget, connectDT), _dec2 = (0, _reactDnd.DragSource)('draggableList', draggableSource, connectDS), _dec(_class = _dec2(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(RowDnD, _Component);

  function RowDnD() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RowDnD.prototype;

  _proto.onSelect = function onSelect() {
    this.setState({
      selected: !this.state.selected
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        connectDragSource = _this$props.connectDragSource,
        connectDropTarget = _this$props.connectDropTarget,
        isDragging = _this$props.isDragging,
        canDrop = _this$props.canDrop,
        isOver = _this$props.isOver,
        rowLength = _this$props.rowLength,
        other = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["connectDragSource", "connectDropTarget", "isDragging", "canDrop", "isOver", "rowLength"]);
    /** Essential to make Componet both Draggable and Droppable */

    return /*#__PURE__*/_react["default"].createElement(_Row["default"], (0, _extends2["default"])({
      className: (0, _utils.classnames)(stClassName + "-tbody-row", {
        dragging: isDragging,
        active: canDrop && isOver
      }),
      style: (0, _extends2["default"])({}, style)
    }, other, {
      ref: function ref(instance) {
        var node = (0, _reactDom.findDOMNode)(instance);
        connectDragSource(node);
        connectDropTarget(node);
      }
    }));
  };

  return RowDnD;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", {
  connectDropTarget: _propTypes["default"].func.isRequired,
  connectDragSource: _propTypes["default"].func.isRequired,
  isDragging: _propTypes["default"].bool,
  isOver: _propTypes["default"].bool,
  canDrop: _propTypes["default"].bool,

  /** Props you like to import */
  index: _propTypes["default"].number,
  onRowMove: _propTypes["default"].func,
  rowLength: _propTypes["default"].number,
  name: _propTypes["default"].string
}), _temp)) || _class) || _class);
exports["default"] = RowDnD;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(479);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var Row = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Row, _Component);

  function Row(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onHover", function () {
      _this.props.onRowHover && _this.props.onRowHover(_this.props.rowKey);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onLeave", function () {
      _this.props.onRowOut && _this.props.onRowOut(_this.props.rowKey);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClick", function () {
      _this.props.onRowClick && _this.props.onRowClick(_this.props.rowKey);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_renderRows", function () {
      var count = 0;
      var totalWidth = 0; // accessibility requirement to add scope as row

      var colToAddScopeRow = _this.props.colToAddScopeRow;

      if (_this.props.widthDivision) {
        Object.keys(_this.props.widthDivision).forEach(function (index) {
          totalWidth += parseInt(_this.props.widthDivision[index].split('px')[0], 0);
          count++;
        });
      }

      totalWidth += 'px';

      if (!_this.props.headerRow) {
        return Array(_this.props.colLength).fill().map(function (item, colIndex) {
          var width = '';

          if (_this.props.widthDivision && _this.props.widthDivision[colIndex]) {
            width = _this.props.widthDivision[colIndex];
          } else {
            width = "calc((100% - " + totalWidth + ") / " + (_this.props.colLength - count) + ")";
          }

          var tdScope = {};

          if (colIndex === colToAddScopeRow) {
            tdScope = {
              scope: 'row'
            };
          }

          return /*#__PURE__*/_react["default"].createElement("td", (0, _extends2["default"])({
            style: {
              minWidth: width,
              maxWidth: width,
              width: width
            },
            key: colIndex
          }, tdScope), _this.props.cellRenderer && _this.props.cellRenderer(_this.props.rowKey, colIndex));
        });
      }

      return Array(_this.props.colLength).fill().map(function (item, colIndex) {
        var width = '';

        if (_this.props.widthDivision && _this.props.widthDivision[colIndex]) {
          width = _this.props.widthDivision[colIndex];
        } else {
          width = "calc((100% - " + totalWidth + ") / " + (_this.props.colLength - count) + ")";
        }

        return /*#__PURE__*/_react["default"].createElement("th", {
          style: {
            minWidth: width,
            maxWidth: width,
            width: width
          },
          key: colIndex,
          scope: "col"
        }, _this.props.headerRenderer && _this.props.headerRenderer(colIndex));
      });
    });
    _this.state = {
      selected: false
    };
    return _this;
  }

  var _proto = Row.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.onRef && this.props.onRef(undefined);
  };

  _proto.onSelect = function onSelect() {
    this.setState({
      selected: !this.state.selected
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        style = _this$props.style;
    var selected = this.state.selected;
    var classNames = (0, _utils.classnames)({
      selected: selected
    });
    return /*#__PURE__*/_react["default"].createElement("tr", {
      style: style,
      className: classNames + " " + className,
      onClick: function onClick() {
        _this2._onClick();
      },
      onMouseOver: function onMouseOver() {
        _this2._onHover();
      },
      onMouseOut: function onMouseOut() {
        _this2._onLeave();
      }
    }, this._renderRows());
  };

  return Row;
}(_react.Component);

exports["default"] = Row;
(0, _defineProperty2["default"])(Row, "propTypes", {
  colToAddScopeRow: _propTypes["default"].number,
  cellRenderer: _propTypes["default"].func,
  className: _propTypes["default"].string,
  colLength: _propTypes["default"].number,
  headerRenderer: _propTypes["default"].func,
  headerRow: _propTypes["default"].bool,
  onRowHover: _propTypes["default"].func,
  onRowOut: _propTypes["default"].func,
  onRef: _propTypes["default"].func,
  rowKey: _propTypes["default"].number,
  style: _propTypes["default"].object,
  widthDivision: _propTypes["default"].object,
  onRowClick: _propTypes["default"].func
});

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

function reOrderRow(arr, from, to) {
  var objData = [].concat(arr);
  objData.splice(to, 0, objData.splice(from, 1)[0]);
  return objData;
}
/**
 * Special case for handling scenario in Windows OS browsers,
 * when scrollbar appears in TBody,
 * learn more from rtc defect 235531
 */


function resizeThead(tbody) {
  var thead = tbody.parentElement.children[0].children[0];

  if (navigator.appVersion.indexOf('Win') !== -1) {
    if (tbody.scrollHeight > tbody.clientHeight) {
      var SCROLLBAR_WIDTH = '17px';
      thead.style.width = "calc(100% - " + SCROLLBAR_WIDTH + ")";
    }
  }
}

var _default = {
  reOrderRow: reOrderRow,
  resizeThead: resizeThead
};
exports["default"] = _default;

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[475,0]]]);
});